import { OperationType } from '@/@types/generated'
import { HandshakeIcon } from 'lucide-react'
import {
  OperationTypesProvider,
  useOperationTypes,
} from '../../../hooks/operation-types'
import SelectTypeButton, { SelectTypeButtonProps } from './SelectTypeButton'
import { PropsWithChildren } from 'react'

interface CaseOperationTypeButtonProps {
  value: number | null
  onChange: SelectTypeButtonProps<OperationType>['onChange']
  disabled?: boolean
}

export function CaseOperationTypeButton({
  ...props
}: PropsWithChildren<CaseOperationTypeButtonProps>) {
  return (
    <OperationTypesProvider>
      <Inner {...props} />
    </OperationTypesProvider>
  )
}

function Inner({
  value,
  disabled,
  onChange,
  ...props
}: Parameters<typeof CaseOperationTypeButton>[0]) {
  // Hooks
  const { operationTypes } = useOperationTypes()

  return (
    <SelectTypeButton
      label="Operation Type"
      options={operationTypes}
      value={operationTypes.find(({ id }) => id === value) || null}
      valueIcon={<HandshakeIcon className="stroke-primary" />}
      disabled={disabled}
      onChange={onChange}
      {...props}
    />
  )
}
